const WPVUE = window.WPVUE;
import { archivePageId, isPastEvent } from "@/plugins/helpers";

import _orderby from "lodash.orderby";
import moment from "moment";

export default {
  isOpenNav: state => state.isOpenNav,
  logoVisible: state => state.logoVisible,
  userOpenNav: state => state.userOpenNav,
  isPageLoaded: state => state.loadedEverything,
  pageIsLoading: state => state.pageIsLoading,
  getCurrentRoute: state => state.route,
  getStoreVersion: state => state.storeVersion,
  getPostsData: state => state.postsData,

  currentPostType: state =>
    state.route.meta && state.route.meta.post_type
      ? state.route.meta.post_type
      : "page",
  currentPageID: (state, getters) => {
    let pageID = getters.currentPage ? getters.currentPage.id : null;
    const postType = getters.currentPostType;

    if (!pageID && postType) pageID = archivePageId(postType);

    return pageID ? Number(pageID) : null;
  },
  currentPage: (state, getters) => {
    let page = null;
    let postType = getters.currentPostType;
    const router = getters.getCurrentRoute;
    let pageToFind = null;

    if (
      router.query &&
      router.query.preview &&
      router.query.preview === "1" &&
      router.query.page_id &&
      router.query.revision_id
    ) {
      pageToFind = Number(router.query.revision_id);
      let revision = state.postsData["revisions"]
        ? state.postsData["revisions"].find(it => pageToFind === it.id)
        : null;
      return revision;
    }
    if (state.postsData && postType) {
      const pagePath = state.route.path;
      const pageUrl = WPVUE.home_url + "" + pagePath;

      if (
        state.route.name === "frontPage" ||
        state.route.name === "search" ||
        pageToFind
      ) {
        if (!pageToFind) {
          postType = "page";
        }
        switch (state.route.name) {
          case "frontPage":
            pageToFind = Number(WPVUE.front_page);
            break;
          case "search":
            pageToFind = Number(WPVUE.options.archives.search_page);
            break;
        }
        page = state.postsData[postType].find(it => pageToFind === it.id);
      } else {
        if (
          state.route &&
          state.route.meta &&
          state.route.meta.type &&
          state.route.meta.type !== "single"
        ) {
          page = state.postsData["page"].find(
            it => archivePageId(postType) === it.id
          );
        } else {
          //console.log("PT:", postType);
          page = state.postsData[postType]
            ? state.postsData[postType].find(it => {
                return (
                  pageUrl.replace(/\/$/, "").replace("www.", "") ===
                  it.link.replace(/\/$/, "").replace("www.", "")
                );
              })
            : "";
        }
      }
    }
    return page;
  },
  getCurrentPageMeta: (state, getters) => {
    if (getters.currentPage && getters.currentPage.seo) {
      const yoast = getters.currentPage.seo,
        page = getters.currentPage;
      if (!page) return null;
      const title = yoast.yoast_wpseo_title
          ? yoast.yoast_wpseo_title
          : page.title.rendered,
        image = page.featured_image_src ? page.featured_image_src.url : "",
        desc = yoast.yoast_wpseo_metadesc
          ? yoast.yoast_wpseo_metadesc
          : page.post_excerpt,
        author = null,
        // author = (getters.getAuthorByID(page.post_author) && getters.getAuthorByID(page.post_author).title.rendered) ? getters.getAuthorByID(page.post_author).title.rendered : '',
        seo = {
          title: title,
          description: desc,
          keywords: yoast["yoast_wpseo_focuskw"]
            ? yoast["yoast_wpseo_focuskw"]
            : title,
          author: author,
          url: page.link,
          site_name: window.WPVUE.site_name,
          og: {
            title: yoast["yoast_wpseo_opengraph-title"]
              ? yoast["yoast_wpseo_opengraph-title"]
              : title,
            image: yoast["yoast_wpseo_opengraph-image"]
              ? yoast["yoast_wpseo_opengraph-image"]
              : image,
            type: "website",
            description: yoast["yoast_wpseo_opengraph-description"]
              ? yoast["yoast_wpseo_opengraph-description"]
              : desc,
            url: page.link,
            site_name: window.WPVUE.site_name
          },
          twitter: {
            description: yoast["yoast_wpseo_twitter-description"]
              ? yoast["yoast_wpseo_twitter-description"]
              : desc,
            title: yoast["yoast_wpseo_twitter-title"]
              ? yoast["yoast_wpseo_twitter-title"]
              : title
          }
        };

      return seo;
    } else {
      return false;
    }
  },
  currentTheme: (state, getters) => postID => {
    //need fix for hierarhical pages
    const defaultTheme = {
      select_color: "#853376",
      text_color: "light"
    };

    let currentPage = getters.currentPage;
    if (postID) {
      currentPage = getters.getPageById(postID);
    }

    const pageThemes = WPVUE.options.avaible_colors;
    let theme = null;
    if (currentPage) {
      if (currentPage.top_parent && currentPage.top_parent !== 0) {
        // is child page
        currentPage = getters.getPageById(currentPage.top_parent);
      }
      if (currentPage && currentPage.acf && currentPage.acf.select_color) {
        theme = pageThemes.filter(
          thm => thm.select_color == currentPage.acf.select_color
        );
      }
    }

    if (theme && theme[0]) {
      theme = theme[0];
    } else {
      theme = defaultTheme;
    }

    return theme;
  },
  /**
   * Need update !
   */
  getCategory: state => (catID, taxonomy) => {
    const tax = taxonomy ? taxonomy : "category";
    if (!catID) return null;
    catID = Number(catID);
    if (state.taxonomies && state.taxonomies[tax]) {
      return state.taxonomies[tax].filter(cat =>
        cat.id === catID ? cat : false
      )[0];
    } else return null;
  },
  getTaxonomy: state => taxonomy => {
    let tax = null;
    if (!taxonomy) taxonomy = "category";
    if (
      state.taxonomies &&
      state.taxonomies[taxonomy] &&
      state.taxonomies[taxonomy].length > 0
    )
      tax = state.taxonomies[taxonomy];
    return tax;
  },
  /**
   * Get post by ID
   *  //TO DO, make it as Action !
   */
  getPageById: state => postID => {
    if (!postID) return false;
    if (!state.loadedEverything) {
      //console.warn('Getter getPageById called too early, try call it after everything is loaded')
      //return false;
    }

    postID = Number(postID);
    if (!(typeof postID == "number")) {
      console.warn("ID must be a number");
      return false;
    }
    let post = undefined;
    for (let postType in state.postsData) {
      post = state.postsData[postType].find(
        posts => Number(posts.id) === Number(postID)
      );
      if (!(typeof post == "undefined")) break;
    }

    return post;
  },
  getAuthorByID: state => authorId => {
    if (state.authors && state.authors.length > 0) {
      let test = state.authors.filter(item => item.id === Number(authorId));
      console.log(test[0])
      if (test[0]) return test[0];
    }
    return false;
  },
  getPostsRelatedToEvent: state => eventID => {
    let posts = null;
    if (state.postsData.post && state.postsData.post.length > 0) {
      posts = state.postsData.post.filter(
        item => item.acf.select_event === eventID
      );
    }
    return posts && posts.length > 0 ? posts : null;
  },
  getPosts: state => (postsCats, postType) => {
    let posts = null;
    if (!postType) postType = "post";
    if (state.postsData[postType] && state.postsData[postType].length > 0) {
      if (postsCats) {
        // check if get only from categories
        //check if it is array
        if (!(postsCats.constructor.toString().indexOf("Array") > -1)) {
          postsCats = [postsCats];
        }
        posts = state.postsData[postType].filter(item => {
          if (item.acf._categories && item.acf._categories.length > 0) {
            return item.acf._categories.some(r => postsCats.includes(r));
          }
        });
      } else {
        posts = state.postsData[postType];
      }
    }
    return posts && posts.length > 0 ? posts : null;
  },
  /**
   * Array or string
   */

  getEvents: state => (eventCats, pastEvents) => {
    let events = null;

    if (
      state.postsData &&
      state.postsData.events &&
      state.postsData.events.length > 0
    ) {
      if (eventCats.length > 0) {
        //check if it is array, if not make it array
        if (!(eventCats.constructor.toString().indexOf("Array") > -1)) {
          eventCats = [eventCats];
        }

        // get events from categories
        events = state.postsData.events.filter(item => {
          if (item.acf._categories.length > 0) {
            return item.acf._categories.some(r => eventCats.includes(r));
          }
        });
      } else {
        events = state.postsData.events;
      }
      if (events.length > 0) {
        events.forEach(eventPost => {
          eventPost.start_date = Number(
            moment(eventPost.acf.start_date).format("x")
          );
          eventPost.end_date = eventPost.acf.end_date
            ? Number(moment(eventPost.acf.end_date).format("x"))
            : eventPost.start_date;
        });
        if (typeof pastEvents !== "undefined") {
          events = state.postsData.events.filter(eventPost => {
            return pastEvents
              ? isPastEvent(eventPost)
              : !isPastEvent(eventPost);
          });
        }
        if (!pastEvents) {
          events =
            events && events.length > 0
              ? _orderby(events, "start_date", "asc")
              : false;
        } else {
          events =
            events && events.length > 0
              ? _orderby(events, "start_date", "desc")
              : false;
        }
        //console.log('Ordered:', events)
      }
    }
    //iltered = _orderby(filtered, 'date', 'desc');
    return events && events.length > 0 ? events : null;
  }
};
